/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var SaveAltIcon = createIcon({
  name: 'SaveAltIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M738.448 397.076l-184.514-223.726c-36.11-36.112-48.226-35.646-83.87 0l-184.514 223.726c-23.063 23.065-15.248 41.936 17.369 41.936h135.938v201.159c-0.002 5.298 0.933 9.666 4.375 13.109 3.442 3.44 7.813 5.166 13.111 5.161h109.735c5.296 0.005 9.666-1.719 13.104-5.161 3.445-3.442 5.959-7.815 5.959-13.109v-201.159h135.938c32.619 0 40.434-18.871 17.369-41.936v0zM877.714 950.857h-877.714v-1024h1024v877.735l-146.286 146.265zM877.714 73.143h-732.425l0.997 731.429h658.286l73.143-73.143v-658.286z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});

export default SaveAltIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/save-alt-icon.js
// module id = 1116
// module chunks = 0